( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-intro' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			window.app.main.initFontAdjustment( this );

			let $currentSection = $( this );

			$currentSection.find( '.js-section-pricing-slider' ).each( function() {
				let $slider = $( this );

				if ( $slider[0].swiper ) {
					$slider[0].swiper.destroy( true, true );
				}

				if ( $slider.find( '.swiper-slide' ).length <= 1 ) {
					return;
				}

				let loopedSlides = 5;
				let loopSlides = true;

				if ( $slider.find( '.swiper-slide' ).length === 1 ) {
					loopedSlides = 0;
					loopSlides = false;
				}

				const loadSlider = () => {
					new Swiper( $slider[0], {
						observer: true,
						observeParents: true,
						slidesPerView: 'auto',
						autoHeight: false,
						slideToClickedSlide: true,
						centeredSlides: false,
						loop: loopSlides,
						rewind: false,
						loopedSlides: loopedSlides,
						loopAdditionalSlides: loopedSlides,
						loopedSlidesLimit: false,
						a11y: {
							enabled: false,
						},
						navigation: {
							nextEl: $currentSection.find( '.swiper-button-next' )[0],
							prevEl: $currentSection.find( '.swiper-button-prev' )[0],
						}
					} );
				};

				window.app.loadVendor( 'Swiper', loadSlider );
			} );
		} );
	};

	window.app.loadBlock( initBlock, 'section-intro', '.section-intro' );
} )( jQuery );
